import { useEffect } from "react";
import { useAuth } from "@clerk/react";
import { setAuthTokenGetter } from "@/lib/api";

// Registers Clerk's getToken() into our axios wrapper so every API call
// is sent with a fresh Bearer token.
export const AuthTokenInjector = () => {
  const { getToken } = useAuth();
  useEffect(() => {
    setAuthTokenGetter(() => getToken());
    return () => setAuthTokenGetter(null);
  }, [getToken]);
  return null;
};

export default AuthTokenInjector;
